// extracted by mini-css-extract-plugin
export default {"client":"Group_client__UDza8","select":"Group_select__NSTe9","minus":"Group_minus__ptOzH"};